'use client';
function createVarsResolver(resolver) {
  return resolver;
}

export { createVarsResolver };
//# sourceMappingURL=create-vars-resolver.mjs.map
